import { ITranslations } from 'src/app/shared/utils/translations';
import { PaymentTemplate } from '../../modules/payments/classes/payment-template.class';

export class TokenizeTemplate extends PaymentTemplate {
  constructor() {
    super();
  }

  public onTranslations(translations: ITranslations): void {
    this.title = translations['payment-add-card'];
    this.description = translations['payment-add-card-description'];
  }
}
